<template>
    <div>
        <!--<div :class="{ 'icon_meal_yes': iconFlg.meal_flag, 'icon_meal_no': !iconFlg.meal_flag }" class="mx-1"></div>-->
        <template v-if="iconFlg.plan_id === 0">
            <div :class="{ 'icon_reserve_phone play-style-icon': Boolean(!iconFlg.plan_id)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.plan_id !== 0 && iconFlg.reserve_situation !== 1">
            <div :class="{ 'icon_reserve_web play-style-icon': Boolean(iconFlg.plan_id)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.reserve_situation === 1">
            <div :class="{ 'icon_reserve_request play-style-icon': Boolean(iconFlg.reserve_situation)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.meal_flag === 0">
            <div :class="{ 'icon_meal_no play-style-icon': Boolean(!iconFlg.meal_flag)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.meal_flag === 1">
            <div :class="{ 'icon_meal_yes play-style-icon': Boolean(iconFlg.meal_flag)}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[1]">
            <div :class="{ 'icon_cart_auto2 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[2]">
            <div :class="{ 'icon_cart_auto4 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[3]">
            <div :class="{ 'icon_cart_auto play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[4]">
            <div :class="{ 'icon_cart_manual play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[5]">
            <div :class="{ 'icon_cart_use1 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[6]">
            <div :class="{ 'icon_cart_use2 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[7]">
            <div :class="{ 'icon_cart_use3 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[8]">
            <div :class="{ 'icon_cart_use4 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[10]">
            <div :class="{ 'icon_cart_auto5 play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <template v-if="cartIcon[11]">
            <div :class="{ 'icon_cart_standingup play-style-icon': 'true'}" class="icon_play_style"></div>
        </template>
        <!-- <template v-if="iconFlg.some_code === 0">
            <div :class="{ 'icon_guarantee_yes play-style-icon': Boolean(iconFlg.some_code)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.some_code === 1">
            <div :class="{ 'icon_guarantee_no play-style-icon': Boolean(!iconFlg.some_code)}" class="icon_play_style"></div>
        </template> -->
        <!--<div :class="{ 'icon_caddie_yes': iconFlg.caddie_flag, 'icon_caddie_no': !iconFlg.caddie_flag }" class="mx-1"></div>-->
        <template v-if="iconFlg.caddie_flag === 0">
            <div :class="{ 'icon_caddie_no play-style-icon': Boolean(!iconFlg.caddie_flag)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.caddie_flag === 1">
            <div :class="{ 'icon_caddie_yes play-style-icon': Boolean(iconFlg.caddie_flag)}" class="icon_play_style"></div>
        </template>
        <!-- <template v-if="iconFlg.some_code === 1">
            <div :class="{ 'icon_guarantee_no': Boolean(iconFlg.some_code)}" class="mx-1"></div>
        </template>
        <template v-if="iconFlg.some_code === 2">
            <div :class="{ 'icon_guarantee_2b': Boolean(iconFlg.some_code)}" class="mx-1"></div>
        </template>
        <template v-if="iconFlg.some_code === 3">
            <div :class="{ 'icon_guarantee_3b': Boolean(iconFlg.some_code)}" class="mx-1"></div>
        </template> -->
        <template v-if="iconFlg.round_code === 1">
            <div :class="{ 'icon_round_9h play-style-icon': Boolean(iconFlg.round_code)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.round_code === 2">
            <div :class="{ 'icon_round_18h play-style-icon': Boolean(iconFlg.round_code)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.round_code === 3">
            <div :class="{ 'icon_round_27h play-style-icon': Boolean(iconFlg.round_code)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.round_code === 4">
            <div :class="{ 'icon_round_36h play-style-icon': Boolean(iconFlg.round_code)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.round_code === 5">
            <div :class="{ 'icon_round_free play-style-icon': Boolean(iconFlg.round_code)}" class="icon_play_style"></div>
        </template>
        <!--<div :class="{ 'icon_accommodation_yes': iconFlg.accommodation_flag, 'icon_accommodation_no': !iconFlg.accommodation_flag }" class="mx-1"></div>-->
        <template v-if="iconFlg.accommodation_flag === 0">
            <div :class="{ 'icon_accommodation_no play-style-icon': Boolean(!iconFlg.accommodation_flag)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.accommodation_flag === 1">
            <div :class="{ 'icon_accommodation_yes play-style-icon': Boolean(iconFlg.accommodation_flag)}" class="icon_play_style"></div>
        </template>
        <!-- シェアプランかはsome_codeを見て判断する -->
        <template v-if="iconFlg.some_code === 0">
            <div :class="{ 'icon_guarantee_yes play-style-icon': Boolean(true)}" class="icon_play_style"></div>
        </template>
        <template v-if="iconFlg.some_code === 1">
            <div :class="{ 'icon_share_yes play-style-icon': Boolean(iconFlg.reserve_type)}" class="icon_play_style"></div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        iconFlg: {
            Type: Array,
            required: true
        },
        dispType: {
            Type: String,
            required: true
        }
    },
    data () {
        return {
            // 9は非表示となるため除外する
            cartIcon: {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
                7: false,
                8: false,
                10: false,
                11: false
            }
        }
    },
    watch: {
        iconFlg: function () {
            this.setCartCode();
        }
    },
    created () {
        this.setCartCode();
    },
    methods: {
        /** ----------------------------------------------
        * カートアイコン切り替え
        * ---------------------------------------------- */
        setCartCode () {
            // アイコンのデータがない場合は全アイコンを非表示
            if(this.iconFlg == undefined || this.iconFlg.cart_code == undefined || this.iconFlg.cart_code.length < 1){
                for(var list in this.cartIcon){
                    this.cartIcon[list] = false;
                }
            }else{
                // 表示するアイコンを切り替え
                this.iconFlg.cart_code.forEach(
                    element => this.cartIcon[element] = true
                );
            }
        }
    }
}
</script>

<style scoped>
.icon_play_style {
    margin-right: 1px;
    margin-left: 1px;
    margin-bottom: 1px;
}
</style>
